
import { defineComponent } from "vue";
import CreateEditDialog from "@/components/controls/catalogueGrid/CreateEditDialog.vue";
import mountComponentMixin from "@/mixins/MountComponentMixin";
import CatalogueSelectControl from "@/components/controls/base/CatalogueSelectControl.vue";
import TextControl from "@/components/controls/base/TextControl.vue";
import { getTransportContainer } from "../../../../api/containerApi";
import IntegerControl from "@/components/controls/base/IntegerControl.vue";
import DecimalControl from "@/components/controls/base/DecimalControl.vue";
import { ability } from "@/abilities/ability";

export default defineComponent({
  components: {
    CreateEditDialog,
    TextControl,
    CatalogueSelectControl,
    IntegerControl,
    DecimalControl,
  },
  mixins: [mountComponentMixin],
  props: {
    saveModelCallback: { required: true },
  },
  computed: {
    isCopyMode() {
      return this.copyMode as boolean;
    },
    hasOrder() {
      return ability.can("view", "Order") as boolean;
    },
  },
  data() {
    return {
      tractorParamsVisibility: false,
      firstDisplay: true,
      model: null,
      copyMode: false,
    };
  },
  methods: {
    onChange() {
      this.setCopyMode(true);
      getTransportContainer(this.model.transportContainerId).then((res) => {
        this.setData(res.data);
      });
    },
    setData(data: any) {
      delete data["id"];
      Object.assign(this.model, data);
    },
    dialog() {
      return this.$refs.dialog as any;
    },
    open(model: any, editType: any) {
      this.dialog().open(model, editType);
      this.model = this.dialog().createEditModel;
      this.firstDisplay = true;
      this.tractorParamsVisibility = false;
      this.setCopyMode(false);
    },
    close() {
      this.dialog().close();
    },
    save() {
      this.dialog().save();
    },
    changeTractorParamsVisibility(visibility: any) {
      this.tractorParamsVisibility = visibility;
    },
    setCopyMode(enabled: any) {
      this.copyMode = enabled;
    },
  },
});
